import { Link } from "react-router-dom";
import { allNews, formatDate } from "@/utils/content";

export default function LatestNews() {
  const latest = allNews.slice(0, 5);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-base font-bold text-foreground-950">最新资讯</h2>
        <Link to="/news" className="text-xs font-medium text-primary-600 hover:text-primary-700">
          查看全部
        </Link>
      </div>
      <ul className="mt-4 divide-y divide-background-200">
        {latest.map((item) => (
          <li key={item.id}>
            <Link to={`/news/${item.id}`} className="group block py-3">
              <h3 className="line-clamp-2 text-sm font-medium leading-relaxed text-foreground-800 transition-colors group-hover:text-primary-600">
                {item.title}
              </h3>
              <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
                <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-700">
                  {item.category}
                </span>
                <span>{formatDate(item.date)}</span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}